module.exports = __webpack_public_path__ + "img/6cc417f.png";